<div class="selection-header" [style.padding-bottom]="'0.3rem'">
  <div>
    <i
      pTooltip="alles auswählen"
      class="fa-regular fa-square-plus table-header-tooltip selection-button"
      (click)="selectAll()"
    ></i>
  </div>
  <div>
    <i
      pTooltip="alles abwählen"
      class="fa-regular fa-square-minus table-header-tooltip selection-button"
      (click)="unselectAll()"
    ></i>
  </div>
</div>
